import { RootState } from '../store';

export const deviceSelectedSelector = (state: RootState) =>
  state.device.deviceSelected;
